import { Image, Text } from '@react-three/drei'

import Panel from './Panel'
import FlatTextClickable from './FlatTextClickable'
import AppStoreButton from './AppStoreButton'

export default function MainPanel({ pages, pageIndex }) {
  const fontSize = 0.06

  const clickCallback = (e) => window.open(e.object.userData.link, '_blank')

  return (
    <>
      <Panel size={[1.5, 3]}></Panel>

      <Text
        renderOrder={10}
        position={[0, 1.4, 0.002]}
        children={pages[pageIndex].description}
        fontSize={fontSize}
        lineHeight={1}
        letterSpacing={-0.05}
        maxWidth={1.5 - 0.15}
        anchorX={'center'}
        anchorY={'top'}
        textAlign={'left'}
        materialToneMapped={false}
      />
      {(pageIndex === 0 || pageIndex === 1) && <AppStoreButton linkURL={pages[pageIndex].callToActionLink} />}
      {pageIndex === 2 && (
        <Image renderOrder={10} url={'./QR/AR Portal QR Code.png'} scale={0.5} position={[0, -0.7, 0.002]}></Image>
      )}
      {pageIndex === 3 && (
        <Image renderOrder={10} url={'./QR/AR Stencil QR Code.png'} scale={0.5} position={[0, -0.7, 0.002]}></Image>
      )}

      {pageIndex === 4 && (
        <FlatTextClickable
          renderOrder={10}
          children={`💳`}
          clickCallback={clickCallback}
          userData={{ link: pages[pageIndex].callToActionLink }}
          position={[0, -1.2, 0.002]}
          fontSize={0.36}
          overflowWrap={'break-word'}
          textAlign={'left'}
          lineHeight={1}
          letterSpacing={-0.05}
          maxWidth={1.4}
          anchorX={'center'}
          anchorY={'middle'}
          materialToneMapped={false}
        />
      )}

      {(pageIndex === 2 || pageIndex === 5 || pageIndex === 6) && (
        <FlatTextClickable
          renderOrder={10}
          children={`📅`}
          clickCallback={clickCallback}
          userData={{ link: pages[pageIndex].callToActionLink }}
          position={[0, -1.2, 0.002]}
          fontSize={0.36}
          overflowWrap={'break-word'}
          textAlign={'left'}
          lineHeight={1}
          letterSpacing={-0.05}
          maxWidth={1.4}
          anchorX={'center'}
          anchorY={'middle'}
          materialToneMapped={false}
        />
      )}
    </>
  )
}
